import { atom } from "recoil";

export const handleShowFields = atom<boolean>({
  key: "handleShowFields",
  default: false,
});
